// extracted by mini-css-extract-plugin
export default {"text":"EmptyTablePlaceholder_text__mcXI5","wrapper":"EmptyTablePlaceholder_wrapper__Y1pHt"};